module.exports = __webpack_public_path__ + "img/img19.20e208fa.png";